module.exports = __webpack_public_path__ + "static/media/sagar_saurav.04fd5edd.jpg";